import { Stack, Typography } from '@mui/material';
import React from 'react';
export const SummaryItem = ({ value, label }) => {
    return (React.createElement(Stack, { my: 4, direction: "row", alignItems: "flex-end", spacing: 0.4 },
        React.createElement(Typography, { color: "secondary", fontWeight: 600, lineHeight: 1, fontSize: { xs: '1.5rem', sm: '2rem' } }, value),
        React.createElement(Typography, { color: "primary", fontSize: "0.875rem", fontWeight: 600, lineHeight: 1.1 }, label)));
};
